

































import Vue from 'vue'
import ColorPatternOption from '@/product/components/printingOptions/ColorPatternOption.vue'
import { ProductColorPattern } from '@/product/types'

export default Vue.extend({
  components: { ColorPatternOption },
  props: {
    colorPatterns: {
      type: Array as () => ProductColorPattern[],
      required: true
    },
    selectedPattern: {
      type: Object as () => ProductColorPattern,
      default: undefined
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: undefined
    }
  },
  computed: {
    isNotPlain(): boolean {
      return !this.$store.getters.isOrderPlainProduct
    }
  }
})
